export enum HockeyPaymentModel {
    PER_TEAM = 'PER_TEAM',
    PER_ATHLETE = 'PER_ATHLETE'
}
